//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHint: false,
            result: {},
            numFound: 0,
            clickAreas: [
                {
                    x: 830,
                    y: 280,
                    scale: 0.8
                },
                {
                    x: 750,
                    y: 280,
                    scale: 0.5
                },
                {
                    x: 710,
                    y: 550,
                    scale: 0.5
                },
                {
                    x: 800,
                    y: 425,
                    scale: 0.7
                },
                {
                    x: 980,
                    y: 160,
                    scale: 1
                }
            ]
        };
    }
};
